import api from "./api";

export const getAllSnmpWalks = async (schemName = null) => {
  try {
    const response = await api.get("/snmpwalkoid/", {
      params: { client: schemName },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching snmpwalkoid entries:", error);
    throw error;
  }
};

export const createSnmpWalk = async (data, schemName = null) => {
  try {
    const response = await api.post("/snmpwalkoid/", data, {
      params: { client: schemName },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating snmpwalkoid:", error);
    throw error;
  }
};

export const updateSnmpWalk = async (id, data, schemName = null) => {
  try {
    const response = await api.put(`/snmpwalkoid/${id}/`, data, {
      params: { client: schemName },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating snmpwalkoid:", error);
     throw error;
  }
};

export const deleteSnmpWalk = async (id, schemName = null) => {
  try {
    const response = await api.delete(`/snmpwalkoid/${id}/`, {
      params: { client: schemName },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting snmpwalkoid:", error);
    throw error;
  }
};
